import { render, staticRenderFns } from "./SfBanner.vue?vue&type=template&id=4f64428d&"
import script from "./SfBanner.vue?vue&type=script&lang=js&"
export * from "./SfBanner.vue?vue&type=script&lang=js&"
import style0 from "./SfBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports